var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import { string, number, shape, oneOf, oneOfType, object } from 'prop-types';
import Bem, { decl } from '@yandex-lego/i-bem-react';
import _iServices from "./../../i-services/i-services.react.js";

var IServices = _iServices.applyDecls();

import _tableauNode__presets from "./../__presets/tableau-node__presets.react.js";

var Presets = _tableauNode__presets.applyDecls();

var DEFAULT_PRESET = 'ru';

function updatePath(url, path) {
    var schema = url.replace(/^(https?:\/\/).*/, '$1');

    url = url.substr(schema.length).split('/');
    if (url.length === 1) {
        url.push('');
    }

    var domain = url.shift();
    url = url.join('/');
    url = url.replace(/^[^?]*/, path);

    return schema + domain + '/' + url;
}

function updateParam(url, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    if (url.match(re)) {
        return url.replace(re, '$1' + key + '=' + value + '$2');
    }

    return url + separator + key + '=' + value;
}

export default decl({
    block: 'tableau-node',
    elem: 'links',
    render: function render() {
        var _props = this.props,
            preset = _props.preset,
            query = _props.query,
            queryParams = _props.queryParams;


        return this.__self.getLinks(preset, query, queryParams);
    }
}, {
    _fixQueryParams: function _fixQueryParams(serviceId, queryParams) {
        queryParams = _extends({}, queryParams);

        if (queryParams.serviceId && !queryParams.clid && serviceId === 'market') {
            queryParams.clid = {
                www: 505,
                search: 521,
                images: 526
            }[queryParams.serviceId] || 52;
        }

        return queryParams;
    },
    _getUrl: function _getUrl(mainUrl, searchParams, query, queryParams) {
        if (!query) {
            return mainUrl;
        }

        var url = mainUrl;
        var path = searchParams.path;
        if (path) {
            url = updatePath(url, path);
        }
        var params = searchParams.params;
        if (params) {
            Object.keys(params).forEach(function (param) {
                var value = params[param];
                value = value.replace('%s', query);

                Object.keys(queryParams).forEach(function (key) {
                    value = value.replace('${' + key + '}', queryParams[key]);
                });

                value = value.replace(/\$\{[^}]*\}/g, '');
                value = encodeURIComponent(value);
                url = updateParam(url, param, value);
            });
        }

        return url;
    },
    getLinks: function getLinks(preset, query, queryParams) {
        var data = Presets.data;
        var searchData = Presets.searchData;
        var presetData = data[preset] || data[DEFAULT_PRESET];

        var res = [];

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = presetData.services[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var serviceId = _step.value;

                var serviceUrl = IServices.serviceUrl(serviceId);
                var title = IServices.serviceName(serviceId);
                var qp = this._fixQueryParams(serviceId, queryParams);
                var url = this._getUrl(serviceUrl, searchData[serviceId] || {}, query, qp);

                // eslint-disable-next-line react/jsx-max-props-per-line
                res.push(React.createElement(
                    Bem,
                    { key: serviceId, elem: 'links', tag: 'a', attrs: { href: url } },
                    title
                ));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return res;
    },


    defaultProps: {
        preset: DEFAULT_PRESET
    },

    propTypes: {
        preset: string,
        query: object,
        queryParams: shape({
            serviceId: oneOfType([string, number]),
            clid: shape({
                www: oneOf([505]),
                search: oneOf([521]),
                images: oneOf([526])
            })
        })
    }
});